<script>

  import { createEventDispatcher, onMount } from 'svelte';
  import { ADDON_ORDER, disableAddon, getMarketingEmailsAddon, LABELS, showChangeAddonUI } from './Addons/addons';
  import { formatMoney, withTax } from '../Common/tools';
  import { M } from '../external';

  export let subscription;

  let dispatch = createEventDispatcher();
  let activeAddons = [];

  let calculateTotalAddonsPrice = () => {
    return activeAddons.reduce((total, addon) => {
      return total + withTax(addon.clientPrice, subscription.activeVatPercent);
    }, 0);
  };

  let changeAddon = async (addon) => {
    if (subscription.manuallyActivated) {
      return;
    }
    let result = await showChangeAddonUI(addon, subscription);
    if (result) {
      dispatch('change', result);
    }
  };

  let removeAddon = async (addon) => {
    if (subscription.manuallyActivated) {
      return;
    }
    let result = await disableAddon(addon);
    if (result) {
      dispatch('change', result);
    }
  };

  let calcClientPrice = (addon) => {
    switch (addon.type) {
      case 'BANDWIDTH':
        return (addon.value / (1024 * 1024 * 1024)) * addon.monthlyPrice;
      case 'MARKETING_EMAILS':
        return addon.value / 1000 * addon.monthlyPrice;
    }
    return addon.clientPrice;
  };

  let addonPriceDependsOnValue = (addon) => {
    switch (addon.type) {
      case 'WEBSITE':
      case 'ADMIN':
      case 'BOOKING':
        return true;
    }
    return false;
  };

  let addonsWithNoSettings = ['BANDWIDTH', 'ECOMMERCE', 'MARKETING_EMAILS'];

  onMount(() => {
    let activeAddonsMap = {};
    subscription.addons.forEach(a => {
      let addon = { ...a };
      activeAddonsMap[addon.type] = addon;
      if (addon.type === 'BANDWIDTH') {
        addon.value = subscription.planUsage?.extraBandwidth || 0;
      }
      addon.clientPrice = calcClientPrice(addon);
    });
    if (subscription.overchargeEmails) {
      let addon = getMarketingEmailsAddon(subscription);
      addon.value = subscription.planUsage?.extraEmails || 0;
      addon.clientPrice = calcClientPrice(addon);
      activeAddonsMap[addon.type] = addon;
    }
    activeAddons = ADDON_ORDER.map(type => activeAddonsMap[type]).filter(currentAddon => !!currentAddon);
  });

</script>
{#if activeAddons.length}
  <div class="col20 f-left">
    <h2 class="col20 f-left f-28 gray-text">{M.MY_ADDONS}</h2>
    <span class="col20 f-left t-left mt-15 f-15" style="color: #999;">
      {M.MY_ADDONS_DESC}
    </span>
  </div>
  <div class="col20 f-left mt-25 mb-25">
    {#each activeAddons as addon}
      <div class="addon-wrapper flex align-center">
        {#if !subscription.manuallyActivated}
          {#if addonsWithNoSettings.includes(addon.type)}
            <a class="addon-wrapper-settings none-soft system-bg-color rounded-effect"
               on:click={() => removeAddon(addon)}>{M.REMOVE}</a>
          {:else}
            <a class="addon-wrapper-settings none-soft system-bg-color rounded-effect"
               on:click={() => changeAddon(addon)}>{M.SETTINGS}</a>
          {/if}
        {/if}

        <div class="flex align-center">
          <div class="addon-number">
            {LABELS[addon.type].valueToStr(addon.value)}
          </div>
          <h3>{LABELS[addon.type]?.name || addon.type}
            {#if !subscription.manuallyActivated}
            <span class="f-14 light-gray-text">
              {LABELS[addon.type].myAddonPriceSummary(addon, subscription.activeVatPercent, subscription.currency, addonPriceDependsOnValue(addon))}
            </span>
            {/if}
          </h3>
        </div>
        {#if !subscription.manuallyActivated}
          <h3 class="flex-none addon-price">
            +{formatMoney(withTax(addon.clientPrice, subscription.activeVatPercent), subscription.currency)}</h3>
        {/if}
      </div>
    {/each}

    {#if !subscription.manuallyActivated}
      <div class="addon-wrapper flex align-center space-between" style="border: none; background: transparent;">
        <div class="flex align-center">
          <h3><b>{M.TOTAL_FROM_ADDONS}</b></h3>
        </div>
        <h3 class="flex-none addon-price">+{formatMoney(calculateTotalAddonsPrice(), subscription.currency)}</h3>
      </div>
    {/if}
  </div>
{/if}
